$(document).ready(function() {
  
   
/*Blog Page*/
$(".other-articles").wrapAll("<div class='other-artilce-wrap'/>");

 
});

$(document).ready(function(){
  $(".other-artilce-wrap .blog-articles__article").slice(0, 3).show();
  $(".new-load-more").on("click", function(e){
    e.preventDefault();
    $(".other-artilce-wrap .blog-articles__article:hidden").slice(0, 3).slideDown();
    if($(".other-artilce-wrap .blog-articles__article:hidden").length == 0) {
      $(".new-load-more").text("No Content").addClass("noContent");
    }
  });
  
})

$(document).ready(function() {

  if($(window).width() < 1025){
   $('.cgud_slider').slick({
       dots: false,
    arrows: false,
     infinite: true,
     autoplay:true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    });
  }

   
  $('.product_panel_3').slick({
       dots: false,
    arrows: false,
     infinite: false,
     autoplay:true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            infinite: true
          }
        }
      ]
    });
   

  
if($('.homepage_slider slider-component ul').length > 0) {
  $('.homepage_slider slider-component ul').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      
    ]
  });
  };
})

$(document).ready(function() {

  function updateClass() {
    if ($(window).width() <= 768) {
       // $('.idsd_detail').removeClass('mb-desk').addClass('mb-mob');
    } else {
      //  $('.idsd_detail').removeClass('mb-mob').addClass('mb-desk');
    }
}
updateClass();
  
$(window).resize(updateClass);





  // Blog Page/
  $(".other-articles").wrapAll("<div class='other-article-wrap'/>");

  // Load more articles
  $(".other-article-wrap .blog-articles__article").slice(0, 3).show();
  $(".new-load-more").on("click", function(e) {
    e.preventDefault();
    $(".other-article-wrap .blog-articles__article:hidden").slice(0, 3).slideDown();
    if ($(".other-article-wrap .blog-articles__article:hidden").length == 0) {
      $(".new-load-more").text("No Content").addClass("noContent");
    }
  });

  // Initialize sliders
  if ($('.homepage_slider.slider-component ul').length > 0) {
    $('.homepage_slider.slider-component ul').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if ($('.homepage_partners .slider_wrap').length > 0) {
    $('.homepage_partners .slider_wrap').slick({
      infinite: true,
      arrows: false,
      autoplay: true,
      dots: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 769,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }

  if ($('.related-posts').length > 0) {
    $('.related-posts').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            arrows: false
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            arrows: false
          }
        }
      ]
    });
  }

  $('.pdsld_slider').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 520,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });

  $('.cussl_slider').slick({
    infinite: true,
    arrows: false,
    dots: false,
    centerMode: true,
    centerPadding: '25vw',
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '10vw'
        }
      },
      {
        breakpoint: 768,
        settings: {
          centerPadding: '5vw'
        }
      }
    ]
  });

  $('.lokbx_slider').slick({
    infinite: true,
    arrows: false,
    autoplaySpeed: 1800,
    speed: 500,
    dots: false,
    variableWidth: true,
    autoplay: true
  });

   
   
   

  $('.fft_item').on('click', function() {
    $('.fftdt_box').hide();
    $(this).toggleClass('active');
    var id = $(this).data('id');
    $('.fftdt_box[data-id="' + id + '"]').show();
    $('.fft_detail').slideToggle();
  });

  var like = $('.like_inner_img');
  var pair = $('.mobile_slider');
  var fbcr_slider = $('.fbcr_slider');
  
  function mobileOnlySlider(like) {
    like.slick({
      autoplay: true,
      speed: 1000,
      infinite: true,
      slidesToShow: 2,
      arrows: false,
      autoplaySpeed: 2000
    });
  
  }
  function fbcr_sliderOnlySlider(fbcr_slider){
    fbcr_slider.slick({
      autoplay: true,
      speed: 1000,
      infinite: true,
       variableWidth: true,
      arrows: false,
      autoplaySpeed: 2000
    });
  }

  function mobileOnlySlider_pair(pair) {
    pair.slick({
      autoplay: true,
      speed: 1000,
      infinite: true,
      slidesToShow: 2,
      arrows: false,
      autoplaySpeed: 2000
    });
  }

  $(window).resize(function(e) {
    if (window.innerWidth < 768) {
      if (!like.hasClass('slick-initialized')) {
        mobileOnlySlider(like);
      }
      if (!fbcr_slider.hasClass('slick-initialized')) { 
         fbcr_sliderOnlySlider(fbcr_slider);
      }
    } else {
      if (like.hasClass('slick-initialized')) {
        like.slick('unslick'); 
      }
      if (fbcr_slider.hasClass('slick-initialized')) { 
        fbcr_slider.slick('unslick'); 
      }
    }

    

    if (window.innerWidth < 768) {
      if (!pair.hasClass('slick-initialized')) {
        mobileOnlySlider_pair(pair);
      }
    } else {
      if (pair.hasClass('slick-initialized')) {
        pair.slick('unslick');
      }
    }
  });

  if (window.innerWidth < 768) {
    mobileOnlySlider(like);
    mobileOnlySlider_pair(pair);
    fbcr_sliderOnlySlider(fbcr_slider);
  }

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.fft_item').length) {
      $('.fft_item.active').removeClass('active');
      $('.fft_detail').slideUp();
    }
  });

  $("body").on("click", ".size_heading span.ce_in button", function() {
    $(this).parent("span.ce_in").find("button.active").removeClass("active");
    $(this).addClass("active");
    $('.size_chart_div table td span.active').removeClass("active");
    var tableId = $(this).data("attribure");
    $('.size_chart_div table td span').hide();
    $('.size_chart_div table td span[data-attribure="' + tableId + '"]').show();
  });

  var glee = {
    min_cart: function() {
      $('#cart-icon-bubble').on('click', function(e) {
        e.preventDefault();
        $('.min_cart').toggleClass('active');
      });

      $('[action="/cart/add"]').on('submit', function(e) {
        e.preventDefault();
        addtocart($(this));
      });

      function addtocart(that) {
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: that.serialize(),
          dataType: 'json',
          success: function(data) {
            get_mincart();
          }
        });
      }

      function get_mincart() {
        $('.min_cart').toggleClass('active');
      }
    },
    menu: function() {
      $('.link_HeaderMenu').on('click', function() {
        var id = $(this).data('id');
        $('.side_menu').toggleClass('active');
        $('body').toggleClass('overflow-hidden');
        $('.sdmu_link').hide();
        $('.sdmu_link[data-id="' + id + '"]').show();
      });

      $('.sdmu_bg').on('click', function() {
        $('.side_menu').toggleClass('active');
        $('body').toggleClass('overflow-hidden');
      });

      $('.sdmu_href').on('click', function() {
        var id = $(this).next('.sdmu_icon').data('id');
        if (!$('.sdmu_second[data-id="' + id + '"]').hasClass('active')) {
          $('.sdmu_second').removeClass('active');
          $('.sdmu_list').removeClass('active');
        }
        $('.sdmu_second[data-id="' + id + '"]').toggleClass('active');
         $(this).closest('.sdmu_list').toggleClass('active');
      });

      // mobile menu
      $('.menu-drawer__close-button').on('click', function() {
        $(this).closest('details').removeAttr('open');
      });
    },
    product_page: function() {
      $('.pdp_accordian .accordion').on('click', function() {
        $(this).toggleClass('active');
        $(this).next('.accordian_panel').slideToggle();
      });
    },
    inner_page: function() {

      /*
       $('.tab-label').click(function() {
        
            var isActive = $(this).hasClass('active');
            $('.tab-label').removeClass('active');
            $('.tab-content').hide();
            if (isActive) {
                 $(this).siblings('.tab-label').removeClass('active');
            }
                $(this).addClass('active');
                var tabContent = $(this).next('.tab-content');
                tabContent.show();
          
        });
       */
      
      $('.tab-label.button').click(function() {
        if(!$(this).hasClass('active')){
          $('.tab-label.button.active').next('.tab-content').slideToggle('up');
          $('.tab-label.button').removeClass('active');
        } 
        $(this).toggleClass('active');
        $(this).next('.tab-content').slideToggle();
      });
      
    },
    show_time: function() {
      var d = new Date();
      var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
      var offset = 8;
      var nd = new Date(utc + (3600000 * offset));
      var time = nd.getHours() + ":" + nd.getMinutes() + ":" + nd.getSeconds();
      $('.ft_time_show').html(time);
    },
    filter: function() {
      $('.fftdt_item').on('click', function() {
        var value = $(this).attr('value');
        var url = $(this).closest('.fftdt_nav').data('val');
        window.location.href = url + value;
      });
    },
    announcement: function() {
      $('.close_anmt').on('click', function() {
        $('.announcement-bar').hide();
        setCookie('bar', 1, 1);
      });
      if (getCookie('bar') != 1) {
        $('.announcement-bar').show();
      }

      function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
      }

      function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
      }

      function eraseCookie(key) {
        var keyValue = getCookie(key);
        setCookie(key, keyValue, '-1');
      }
    },
    home_page: function() {
      $('.home_page, .idsd_flx').slick({
        infinite: true,
      slidesToShow: 1,
      cssEase: 'linear',
      slidesToScroll: 1,
      arrows: false,
       autoplay: true,
      adaptiveHeight: true,
      dots: true
      });

     
      var tab_slider = $('.ipdcl_list_flx');

      t_slider();
      
      function t_slider(){
          tab_slider.slick({
            infinite: false,
            variableWidth: true,
            arrows: false,
            dots: false
          });   
      }
     

      

      $('.ipdcl_tab_name').on('click', function() {
        tab_slider.slick('unslick');
        var id = $(this).data('id');
        var top_s = $(this).closest('.ipdcl_section');
        top_s.find('.ipdcl_tab_name').removeClass('active');
        top_s.find('.ipdcl_flx').removeClass('active');
        top_s.find('.ipdcl_tab_name[data-id="' + id + '"]').addClass('active');
        top_s.find('.ipdcl_flx[data-id="' + id + '"]').addClass('active');

        $(this).closest('.ipdcl_tab_box').find('.ipdcl_tab_value').html($(this).html());
        t_slider();
        if($(window).width() < 769){
          $(this).closest('.ipdcl_tab_box').find('.ipdcl_tab').slideToggle();
        }
      });

      $('.ipdcl_tab_value').on('click', function() {
        $(this).toggleClass('active');
        $(this).closest('.ipdcl_tab_box').find('.ipdcl_tab').slideToggle();
      });
      
    },
    all_option: function () {
      $('.Show_more_btn').on('click', function(){
        $('.care_inner').show();
        $(this).hide();
      });
    }
  }

  glee.menu();
  glee.product_page();
  glee.inner_page();
  glee.filter();
  glee.announcement();
  setInterval(function() {
    glee.show_time();
  }, 1000);
  glee.home_page();

  glee.all_option();

   
});



